module.exports = "pegasus/assets/summer_header_image.jpg";